import { motion } from "framer-motion";
import { Gem, HandHeart, Wrench, FileText } from "lucide-react";

const ITEMS = [
  {
    icon: Gem,
    title: "Calidad Premium",
    text: "Materiales de alta gama, telas duraderas y mecanismos confiables que elevan el carácter de cada espacio.",
  },
  {
    icon: HandHeart,
    title: "Atención Personalizada",
    text: "Asesoría a medida: estilo, función y presupuesto. Acompañamos cada proyecto de principio a fin.",
  },
  {
    icon: Wrench,
    title: "Instalación Profesional",
    text: "Equipo experto, instalación limpia y precisa. Garantía de acabado en cada montaje.",
  },
  {
    icon: FileText,
    title: "Cotización Sin Compromiso",
    text: "Visita, medición y propuesta detallada sin costo. Tú decides cuándo y cómo avanzar.",
  },
];

export default function Benefits() {
  return (
    <section
  id="beneficios"
  data-testid="benefits-section"
  className="bg-white pt-12 md:pt-16 pb-24 md:pb-32"
>
      <div className="max-w-[1320px] mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-14 md:mb-20">
          <div className="eyebrow mb-5">Marca de confianza</div>
          <h2 className="font-display font-semibold text-persia-black text-3xl md:text-5xl leading-[1.1]">
            ¿Por qué elegir <span className="italic font-light text-gold">Persia</span>
            <br className="hidden md:block" /> Persianas y Cortinas?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-7">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.title}
                data-testid={`benefit-card-${i}`}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, delay: i * 0.08, ease: [0.2, 0.6, 0.2, 1] }}
                className="luxury-card p-8 md:p-9 group"
              >
                <div className="w-14 h-14 border border-gold flex items-center justify-center mb-7 group-hover:bg-gold transition-colors duration-500">
                  <Icon size={22} className="text-gold group-hover:text-persia-black transition-colors duration-500" />
                </div>
                <h3 className="font-display font-semibold text-persia-black text-lg md:text-xl mb-3 leading-tight">
                  {it.title}
                </h3>
                <p className="text-persia text-sm leading-relaxed font-light">{it.text}</p>

                <div className="mt-7 h-px w-10 bg-gold transition-all duration-500 group-hover:w-24" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
